import gql from 'graphql-tag'

// country field is required if an address mutation (postalCode, street and city) is being made.
export const ACCOUNT_UPDATE_MUTATION = gql`
    mutation accountUpdateMutation(
        $amountPurchasedAnnually: AnnualPurchaseType
        $amountPurchasedAnnuallyOnline: AnnualPurchaseOnlineType
        $announcements: Boolean
        $askAvgB2bTurnoverPerYear: AverageB2bTurnoverQuestion
        $askAvgB2cTurnoverPerYear: AverageB2cTurnoverQuestion
        $askSellingInCountries: SellingInCountriesQuestion
        $businessSize: BusinessSize
        $softwarePos: String
        $softwareEcom: String
        $isInterestedInDropshipping: Boolean
        $blog: Boolean
        $categories: [String]
        $city: String
        $cocNumber: String
        $country: String
        $creditsafeId: String
        $dutchDesign: ScoreType
        $ecoFriendly: ScoreType
        $elevatorPitch: String
        $emailFinance: String
        $email: String
        $eoriNumber: String
        $facebookUsername: String
        $fairTrade: ScoreType
        $fastShipping: ScoreType
        $featured: Boolean
        $followerUpdate: Boolean
        $followTheBrand: Boolean
        $handmade: ScoreType
        $highMargins: ScoreType
        $houseNumber: String
        $invoiceStreet: String
        $invoiceHouseNumber: String
        $invoicePostalCode: String
        $invoiceCity: String
        $inbox: Boolean
        $brandCommunications: Boolean
        $incorporationYear: String
        $instagramUsername: String
        $isBnplRequested: Boolean
        $locallyProduced: ScoreType
        $lowConsumerPrices: ScoreType
        $lowMinimumOrderValue: ScoreType
        $marketplaceViewType: String
        $phone: String
        $mobilePhone: String
        $mailingsubDropshipping: Boolean
        $mailingsubInsightsAndGuidance: Boolean
        $companyName: String
        $registeredCompanyName: String
        $notSoldOn: ScoreType
        $onlineStoresCount: OnlineStoresCount
        $organic: ScoreType
        $payAfterArrival: ScoreType
        $physicalStoresCount: PhysicalStoresCount
        $pinterestUsername: String
        $postalCode: String
        $priceRange: PriceRange
        $primaryCategoryId: BigInt
        $signupStatus: SignupStatus
        $social: ScoreType
        $storeType: StoreType
        $storeTypeDescription: String
        $street: String
        $subscribedGlobal: Boolean
        $subscribedService: Boolean
        $url: String
        $vatNumber: String
        $weekly: Boolean
        $settingUpStore: Boolean
        $hasEuFulfilment: Boolean
        $hasEuEntity: Boolean
        $isSmallBusiness: Boolean
        $storefrontPromotionalCode: String
        $iban: String
        $bankHolder: String
        $signupIntent: String
        $retailerType: RetailerType
        $hideEmailForMarketplace: Boolean
        $hideEmailForDropshipping: Boolean
        $isCheckoutCart: Boolean
    ) {
        accountUpdate(
            input: {
                retailerType: $retailerType
                city: $city
                cocNumber: $cocNumber
                companyName: $companyName
                registeredCompanyName: $registeredCompanyName
                country: $country
                creditsafeId: $creditsafeId
                eoriNumber: $eoriNumber
                email: $email
                emailFinance: $emailFinance
                hideEmailForMarketplace: $hideEmailForMarketplace
                hideEmailForDropshipping: $hideEmailForDropshipping
                facebookUsername: $facebookUsername
                houseNumber: $houseNumber
                invoiceStreet: $invoiceStreet
                invoiceHouseNumber: $invoiceHouseNumber
                invoicePostalCode: $invoicePostalCode
                invoiceCity: $invoiceCity
                instagramUsername: $instagramUsername
                phone: $phone
                mobilePhone: $mobilePhone
                pinterestUsername: $pinterestUsername
                postalCode: $postalCode
                signupStatus: $signupStatus
                street: $street
                url: $url
                vatNumber: $vatNumber
                isBnplRequested: $isBnplRequested
                isSmallBusiness: $isSmallBusiness
                storefrontPromotionalCode: $storefrontPromotionalCode
                iban: $iban
                bankHolder: $bankHolder
                isCheckoutCart: $isCheckoutCart
                signupIntent: $signupIntent
                preferences: {
                    amountPurchasedAnnually: $amountPurchasedAnnually
                    amountPurchasedAnnuallyOnline: $amountPurchasedAnnuallyOnline
                    askAvgB2bTurnoverPerYear: $askAvgB2bTurnoverPerYear
                    askAvgB2cTurnoverPerYear: $askAvgB2cTurnoverPerYear
                    askSellingInCountries: $askSellingInCountries
                    businessSize: $businessSize
                    softwarePos: $softwarePos
                    softwareEcom: $softwareEcom
                    isInterestedInDropshipping: $isInterestedInDropshipping
                    categoryPaths: $categories
                    dutchDesign: $dutchDesign
                    ecoFriendly: $ecoFriendly
                    fairTrade: $fairTrade
                    fastShipping: $fastShipping
                    handmade: $handmade
                    highMargins: $highMargins
                    locallyProduced: $locallyProduced
                    lowConsumerPrices: $lowConsumerPrices
                    lowMinimumOrderValue: $lowMinimumOrderValue
                    notSoldOn: $notSoldOn
                    onlineStoresCount: $onlineStoresCount
                    organic: $organic
                    social: $social
                    payAfterArrival: $payAfterArrival
                    physicalStoresCount: $physicalStoresCount
                    incorporationYear: $incorporationYear
                    settingUpStore: $settingUpStore
                    priceRange: $priceRange
                    primaryCategoryId: $primaryCategoryId
                    storeType: $storeType
                    storeTypeDescription: $storeTypeDescription
                    elevatorPitch: $elevatorPitch
                    mailingsubWeekly: $weekly
                    mailingsubFeatured: $featured
                    mailingsubFollowthebrand: $followTheBrand
                    mailingsubFollowerUpdate: $followerUpdate
                    mailingsubSubscribedService: $subscribedService
                    mailingsubSubscribed: $subscribedGlobal
                    mailingsubAnnouncements: $announcements
                    mailingsubBlog: $blog
                    mailingsubInbox: $inbox
                    mailingsubBrandCommunications: $brandCommunications
                    mailingsubDropshipping: $mailingsubDropshipping
                    mailingsubInsightsAndGuidance: $mailingsubInsightsAndGuidance
                    marketplaceViewType: $marketplaceViewType
                    hasEuFulfilment: $hasEuFulfilment
                    hasEuEntity: $hasEuEntity
                }
            }
        ) {
            clientMutationId
            account {
                approvalStatus
                signupStatus
                street
                postalCode
                city
                country
                invoiceStreet
                invoiceHouseNumber
                invoicePostalCode
                invoiceCity
                eoriNumber
                name
                iban
                bankHolder
                hideEmailForMarketplace
                hideEmailForDropshipping
                preferences {
                    physicalStoresCount
                    onlineStoresCount
                    isInterestedInDropshipping
                    softwareEcom
                }
            }
            userErrors {
                field
                message
            }
        }
    }
`

export const ACCOUNT_EMAIL_SETTINGS_UPDATE_MUTATION = gql`
    mutation accountEmailSettingsUpdateMutation(
        $input: AccountEmailSettingsUpdateInput!
    ) {
        accountEmailSettingsUpdate(input: $input) {
            clientMutationId
            userErrors {
                field
                message
            }
        }
    }
`

export const USER_UPDATE_MUTATION = gql`
    mutation userUpdateMutation(
        $firstName: String
        $lastName: String
        $phone: String
        $email: Email
        $timezone: String
        $lastVisitedEnvironment: String
    ) {
        userUpdate(
            input: {
                firstName: $firstName
                lastName: $lastName
                phone: $phone
                email: $email
                timezone: $timezone
                lastVisitedEnvironment: $lastVisitedEnvironment
            }
        ) {
            clientMutationId
            userErrors {
                field
                message
            }
        }
    }
`

export const INTEGRATION_SETTINGS = gql`
    mutation integrationConfigUpdate($input: IntegrationConfigUpdateInput!) {
        integrationConfigUpdate(input: $input) {
            success
            userErrors {
                field
                message
            }
        }
    }
`

export const LEGACY_VALIDATE_VAT_NUMBER = gql`
    query validateVatNumber($vat: String!, $country: String!) {
        vatValidation(vat: $vat, country: $country)
    }
`

export const VALIDATE_VAT_NUMBER = gql`
    mutation validateVatNumber($input: ValidateVatNumberInput!) {
        validateVatNumber(input: $input) {
            isValid
            userErrors {
                message
                name
            }
        }
    }
`
